import styled from '@emotion/styled'
import { de } from 'date-fns/locale'
import { Text } from 'kai-kit'
import { FC } from 'react'
import { Button as RACButton } from 'react-aria-components'
import type { ButtonProps as RACButtonProps } from 'react-aria-components'
import { IconContext } from 'react-icons/lib'

export type CredTypeButtonProps = RACButtonProps & {
  icon: React.ReactNode
  title: string
  description: string
}

export const CredTypeButton: FC<CredTypeButtonProps> = ({ icon, description, title, ...props }) => {
  return (
    <IconContext.Provider value={{ size: '48px', color: 'var(--kai-color-sys-dominant)' }}>
      <StyledButton {...props}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'var(--kai-size-sys-space-sm)',
          }}
        >
          {icon}
          <Text typo='title-lg' color='var(--kai-color-sys-on-dominant-backing)'>
            {title}
          </Text>
        </div>
        <Text typo='body-md' color='var(--kai-color-sys-on-layer-minor)' align='center'>
          {description}
        </Text>
      </StyledButton>
    </IconContext.Provider>
  )
}

const StyledButton = styled(RACButton)`
  appearance: none;
  border: none;
  background: none;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--kai-size-sys-space-xs);
  flex: 1;
  /* width: 100%; */
  min-width: 240px;

  padding: var(--kai-size-sys-space-md);
  border-radius: var(--kai-size-sys-round-md);
  background: var(--kai-color-sys-layer-farther);
  border: 1px solid var(--kai-color-sys-dominant-outline);

  cursor: pointer;
  transition: background var(--kai-motion-sys-duration-fast) var(--kai-motion-sys-ease-in-out);
  &[data-hovered] {
    background: var(--kai-color-sys-layer-nearer);
  }
`
